import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { policySettingItems } from "../constants/policySettings";
import { API_BASE } from "../utils/apiBase";

function PolicySettingPage() {
  const { key } = useParams();
  const rawKey =
    key ||
    (window.location.pathname.includes("/policy-setting/")
      ? window.location.pathname.split("/policy-setting/")[1]?.split("/")[0]
      : "");
  const effectiveKey = !rawKey || rawKey === "undefined" || rawKey === "null" ? "terms-and-conditions" : rawKey;
  const editorRef = useRef(null);
  const [contentHtml, setContentHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const currentLabel = policySettingItems.find((item) => item.key === effectiveKey)?.label || "Policy";

  useEffect(() => {
    let active = true;
    setLoading(true);
    axios
      .get(`${API_BASE}/policy-pages/admin/${encodeURIComponent(effectiveKey)}`)
      .then((res) => {
        if (!active) return;
        const html = res?.data?.contentHtml || "";
        setContentHtml(html);
        if (editorRef.current) editorRef.current.innerHTML = html;
      })
      .catch(() => Swal.fire("Load failed", "Policy data could not be loaded.", "error"))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [effectiveKey]);

  const sync = () => {
    setContentHtml(editorRef.current?.innerHTML || "");
  };

  const run = (cmd, value = null) => {
    document.execCommand(cmd, false, value);
    sync();
  };

  const setFontPx = (px) => {
    if (!px) return;
    run("fontSize", "7");
    const root = editorRef.current;
    if (!root) return;
    root.querySelectorAll("font[size='7']").forEach((node) => {
      node.removeAttribute("size");
      node.style.fontSize = `${px}px`;
    });
    sync();
  };

  const addLink = () => {
    const url = window.prompt("Link URL din (https://...)");
    if (!url) return;
    run("createLink", url);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.post(`${API_BASE}/policy-pages/admin/${encodeURIComponent(effectiveKey)}`, { contentHtml });
      Swal.fire("Saved", "Policy content updated successfully.", "success");
    } catch (error) {
      Swal.fire("Save failed", error?.response?.data?.message || "Could not save.", "error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: "24px" }}>Loading...</div>;

  return (
    <div style={{ padding: "24px" }}>
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h4 className="mb-3">Our Policy Setting: {currentLabel}</h4>
          <div className="d-flex flex-wrap gap-2 mb-2">
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => run("bold")}>Bold</button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => run("italic")}>Italic</button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => run("underline")}>Underline</button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => run("insertUnorderedList")}>Bullet</button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => run("insertOrderedList")}>Number</button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={addLink}>Link</button>
            <select className="form-select form-select-sm" style={{ width: 120 }} onChange={(e) => setFontPx(e.target.value)} defaultValue="">
              <option value="">Text Size</option>
              <option value="12">12</option>
              <option value="14">14</option>
              <option value="16">16</option>
              <option value="18">18</option>
              <option value="22">22</option>
              <option value="28">28</option>
            </select>
          </div>
          <div
            ref={editorRef}
            contentEditable
            suppressContentEditableWarning
            onInput={sync}
            style={{
              minHeight: 420,
              border: "1px solid #ced4da",
              borderRadius: 8,
              padding: 12,
              background: "#fff",
              outline: "none",
            }}
          />
          <button type="button" className="btn btn-success mt-3" onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PolicySettingPage;
